import { render, staticRenderFns } from "./activeTask.vue?vue&type=template&id=18022a10&"
import script from "./activeTask.vue?vue&type=script&lang=js&"
export * from "./activeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports